// tslint:disable:variable-name
export class ReferenceDataModel {
    public static BondType = 'BondType';
    public static Currency = 'Currency';
    public static Rating = 'Rating';
    public static Bondcoins = 'Bondcoins';
    public static IssuerName = 'IssuerName';
    public static CountryOfRisk = 'CountryOfRisk';
}
